export class SystemSecurityPlanApproval {
  systemSecurityPlanApprovalId: number;
  clientITProfileId: number;
  name: string;
  date: string;
  title: string;
  providerName: string;
}
